import { Component, Input, OnInit, signal } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Announcement, LookupValue } from '../../../core/models/announcement.model';
import { LookupService } from '../../../core/services/lookup.service';
import { map } from 'rxjs';

@Component({
  selector: 'app-listing-card',
  standalone: true,
  imports: [CommonModule, RouterLink, CurrencyPipe, DatePipe],
  templateUrl: './listing-card.component.html',
  styleUrls: ['./listing-card.component.scss']
})
export class ListingCardComponent implements OnInit {
  @Input({ required: true }) listing!: Announcement;

  displayLocation = signal<string>('');
  displayPropertyType = signal<string>('');

  constructor(private lookupService: LookupService) {}

  ngOnInit() {
    this.displayLocation.set(this.listing.address || this.listing.region || '');

    if (this.listing.administrativeArea) {
      if (this.isLookup(this.listing.administrativeArea)) {
        const name = this.listing.administrativeArea.name;
        const location = this.listing.address ? `${name}, ${this.listing.address}` : name;
        this.displayLocation.set(location);
      } else {
        this.lookupService.getAdministrativeAreas().pipe(
          map(areas => Array.isArray(areas) ? areas.find(a => a.id === this.listing.administrativeArea)?.name : undefined)
        ).subscribe(name => {
          if (name) {
            const location = this.listing.address ? `${name}, ${this.listing.address}` : name;
            this.displayLocation.set(location);
          }
        });
      }
    }

    if (this.isLookup(this.listing.propertyType)) {
      this.displayPropertyType.set(this.listing.propertyType.name);
    } else if (typeof this.listing.propertyType === 'number') {
      this.lookupService.getPropertyTypes().pipe(
        map(types => Array.isArray(types) ? types.find(t => t.id === this.listing.propertyType)?.name : undefined)
      ).subscribe(name => {
        if (name) this.displayPropertyType.set(name);
      });
    } else {
      this.displayPropertyType.set(this.listing.propertyType?.toString() || '');
    }
  }

  isLookup(val: any): val is LookupValue {
    return !!(val && typeof val === 'object' && 'name' in val);
  }

  get formattedRooms(): string {
    const rooms = this.listing.rooms || this.listing.roomCount;
    if (!rooms) return '';
    return this.isLookup(rooms) ? rooms.name : rooms.toString();
  }

  get formattedFloor(): string {
    const floor = this.listing.floor;
    const totalFloors = this.listing.total_floors || this.listing.totalFloors;

    if (floor === undefined || floor === null) return '';

    const floorStr = this.isLookup(floor) ? floor.name : floor.toString();
    if (!totalFloors) return floorStr;

    const totalStr = this.isLookup(totalFloors) ? totalFloors.name : totalFloors.toString();
    return `${floorStr}/${totalStr}`;
  }
}
